import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { MsalInterceptor, MsalService } from '@azure/msal-angular';

/**
 * Functional interceptor that wraps the class-based MsalInterceptor.
 * This bridges the gap until @azure/msal-angular provides a native HttpInterceptorFn.
 *
 * When no MSAL account is available (user not logged in), the interceptor is skipped
 * to prevent triggering an interactive login redirect on public/noAuth pages.
 */
export const customMsalInterceptorFn: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const msalService = inject(MsalService);
  const account =
    msalService.instance.getActiveAccount() ?? msalService.instance.getAllAccounts()[0];

  if (!account) {
    return next(req);
  }
  const msalInterceptor = inject(MsalInterceptor);
  return msalInterceptor.intercept(req, { handle: next });
};
